// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCJz71JpM4WkryW0FE7SsEN0ppi2UXCThA",
  authDomain: "itok-381523.firebaseapp.com",
  projectId: "itok-381523",
  storageBucket: "itok-381523.appspot.com",
  messagingSenderId: "772939182035",
  appId: "1:772939182035:web:2a8441b7fa0076bf144926",
  measurementId: "G-J5V10SJD1P"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
